import(/* webpackMode: "eager", webpackExports: ["JanesvilleStorageTypes"] */ "/app/app/janesville-warehousing-services/JanesvilleStorageTypes.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["TextImageSection"] */ "/app/components/TextImageSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["WarehousingExcellence"] */ "/app/components/WarehousingExcellence.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["WarehousingHero"] */ "/app/components/WarehousingHero.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["WarehousingValueAddedServices"] */ "/app/components/WarehousingValueAddedServices.tsx");
